export default "/fonts/icon-font.ttf?42800f508da0e675c5435906705ad1ba";